<template>
  <div class="container-cap" id="establishments-o4-results">
    <div class="row">
      <div class="col-xs-12">
        <h1 class="text-primary">
          <small >
            <span v-if="!isNational">
              {{ region }}
            </span>
            <span v-else>
              Programme National
            </span>
            {{ year }}
          </small>
          <br>
          Résultats <span class="label label-observa4">OBSERVA4</span>
        </h1>
      </div>
      <div class="col-xs-12">
        <hr>
      </div>
      <div class="col-xs-12">
        <div class="panel panel-info">
          <div class="panel-heading">
            <div class="form-inline">
              <div v-if="datasetList.length === 0">
                <strong>
                  <sui-loading-text>Récupération des jeux de données</sui-loading-text>
                </strong>
              </div>
              <div v-else class="form-group">
                <dropdown ref="dropdown">
                  <btn type="default" class="dropdown-toggle">
                    <span v-if="dataset == null">
                      Jeu de donnée
                    </span>
                    <span v-else>
                      {{ dataset }}
                    </span>

                    <span class="caret"></span>
                  </btn>
                  <template slot="dropdown">
                    <li v-for="d in datasetList"
                        :key="`dataset-${d}`">
                      <a role="button" @click="dataset = d">
                        {{ d }}
                      </a>
                    </li>
                  </template>
                </dropdown>
              </div>
              <span v-if="dataset">
                <span v-show="!loaded">
                  <strong>
                    <sui-loading-text>Récupération des données</sui-loading-text>
                  </strong>
                </span>
                <span v-show="loaded">
                  <div class="form-group">
                    <div class="input-group">
                      <input required ref="input"
                             id="input" tabindex="0"
                             class="form-control" v-model="text"
                             type="text"
                             placeholder="Chercher un établissement..."
                             autocomplete="off"/>
                      <div class="input-group-addon">
                        <a role="button" @click="selection = null">
                          Effacer
                        </a>
                      </div>
                    </div>
                    <typeahead v-model="selection"
                               open-on-focus
                               force-select
                               target="#input"
                               :data="establishmentList"
                               item-key="value"/>
                  </div>
                </span>
              </span>
            </div>
          </div>
        </div>
        <hr>
      </div>
      <div class="col-xs-12" v-if="dataset">
        <div class="row">
          <sui-filter-bar :multiFilterData="filterInputList"
                          :multiFilterEvents="filterEvents"
                          :selectionInfo="filterSelectionInfo">
          </sui-filter-bar>
          <save-blob :target="csv"></save-blob>

          <div class="col-xs-12" v-if="distribution != null">
            <h3 v-if="selection != null">
              {{ selection.surveillance.establishment.name }}
            </h3>
            <sui-observa4-results :title="title"
                                  :year="parseInt(year)"
                                  :subtitle="subtitle"
                                  :region="true"
                                  :distribution="distribution">
            </sui-observa4-results>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import assert from '@/sui/tools/assert'
import distribution from '@/sui/data/distribution'
import { mapGetters, mapState } from 'vuex'
import regions from '@/sui/tools/regions'
import suiObserva4Results from '@/sui/components/results/observa4'
import sc from '@/sui/sc/sheetCaracteristics'
import suiFilterBar from '@/sui/components/filter/filterbar'
import suiLoadingText from '@/sui/components/loadingtext'
import moment from 'moment'
import csv from '@/sui/data/sheets/csv'
import saveBlob from '@/sui/components/saveblob'

function toVariableName (text) {
  text = text.replace(/%/g, 'pourcents')
  text = text.replace(/\s/g, '_')
  text = text.replace(/è|é/g, 'e')
  return text
}

export default {
  name: 'surveillance-o4-results',

  data: function () {
    return {
      dataset: null,
      selection: null,
      text: '',
      csv: null,
      allSheets: null,
      currentFilter: '',
      referenceSheets: null,
      filterCollapse: true,
      totalSheetCount: 0,
      computeAndAddCompliancesToCSVExport: true
    }
  },

  mounted: function () {
    if (this.datasetList.length === 0) {
      this.$store.dispatch('dataset/allSpiadiNames', !this.isNational)
    }
  },

  methods: {
    addComplianceToSheets: function () {
      const sheets = this.referenceSheets

      const c = distribution('observa4Compliance', this.referenceSheets, this.year)
      const compliance = c[0]
      const err = c[1]

      if (err) {
        this.$notify({
          type: 'danger',
          title: 'Erreur !',
          duration: 0,
          content: `Une erreur est survenue pendant le calcul des conformités par fiches : ${err}.`
        })
        return
      }

      for (let i = 0; i < sheets.length; i++) {
        const sh = sheets[i]
        const shid = sh.id
        const shCompliance = compliance[shid]

        for (let j in shCompliance) {
          const name = toVariableName(j)
          assert.isNull(sh.f[name])
          sh.f[name] = shCompliance[j]
        }
      }
    },

    fill: function () {
      this.selection = null

      const request = {
        name: this.dataset,
        mod: 'observa4',
        step: 1
      }
      const vm = this
      this.$store.dispatch('dataset/sheets', request).then(
        (r) => {
          if (r.data.err == null) {
            vm.allSheets = Object.freeze(r.data.v)
          } else {
            vm.$notify(
              {
                type: 'danger',
                title: 'Erreur !',
                duration: 0,
                content: `Une erreur est survenue pendant la récupération
              des fiches observa4 : ${r.data.err}`
              }
            )
          }
        }
      ).catch(
        e => {
          vm.$notify(
            {
              type: 'danger',
              title: 'Erreur !',
              duration: 0,
              content: `Une erreur est survenue pendant la récupération
              des fiches observa4 : ${e}`
            }
          )
        }
      )

      if (!this.display) {
        this.$store.dispatch('surveillances/all', this.year)
      }
    },
    exportCSV: function (e) {
      if (this.computeAndAddCompliancesToCSVExport) {
        this.addComplianceToSheets()
        this.computeAndAddCompliancesToCSVExport = false
      }

      const { filter, lists } = e
      if (lists.length !== 1) {
        return
      }

      const list = lists[0]
      if (list.length === 0) {
        return
      }

      const date = moment().format('DD-MM-YYYY-HH-mm-ss')
      const filename = `${this.dataset} - OBSERVA4 - ${date} - ${filter}.csv`
      const vm = this
      csv(
        filename,
        this,
        this.surveillances,
        'observa4',
        this.year,
        list,
        (r) => {
          vm.csv = r
        },
        vm.setError
      )
    },

    onListFiltered: function (e) {
      const { filter, lists, data } = e
      if (lists.length !== 1) {
        return
      }

      this.currentFilter = filter
      this.referenceSheets = lists[0]
      this.totalSheetCount = data[0].length
    }
  },

  watch: {
    year: function () {
      this.dataset = null
      this.referenceSheets = null
      this.allSheets = null
    },

    dataset: function () {
      this.fill()
    },

    selection: function (val) {
      if (val != null) {
        this.text = this.selection.value
      } else {
        this.text = ''
      }
    }
  },

  computed: {
    ...mapState({
      datasets: state => state.dataset.names.values,
      allSurv: state => state.surveillances.all
    }),

    ...mapGetters({
      getListByName: 'surveillances/listByName',
      loginRegion: 'login/region'
    }),

    surveillances: function () {
      return this.allSurv[this.year]
    },

    datasetList: function () {
      return this.datasets[this.year].filter(
        d => d.match(/SPIADI[0-9]{4}($|-OBS[4P]-)/) != null
      )
    },

    filterEvents: function () {
      const result = {
        filter: this.onListFiltered
      }

      if (this.isNational) {
        result.csv = this.exportCSV
      }

      return result
    },

    filterSelectionInfo: function () {
      if (this.referenceSheets == null) {
        return null
      }

      return {
        statistics: {
          count: this.referenceSheets.length,
          total: this.totalSheetCount
        },
        filter: this.currentFilter
      }
    },

    isNational: function () {
      return this.$route.path.match(/^\/mission/)
    },

    region: function () {
      if (this.isNational || this.loginRegion == null) {
        return null
      }

      return regions.regions[this.loginRegion].name
    },

    establishmentByRegions: function () {
      if (this.establishmentList == null) {
        return null
      }

      const result = {}

      this.establishmentList.forEach(
        e => {
          const f = e.surveillance.establishment.finess
          const ri = regions.indexOf(f)
          result[e.surveillance.id] = ri
        }
      )
      return result
    },

    filterVariables: function () {
      const result = sc.filterVariables.observa4(this.year)
      result.push(
        {
          key: 'finess',
          name: 'Finess',
          field: (s) => {
            const e = this.establishmentList.find(e => e.surveillance.id === s.sv)
            return e == null ? [] : [e.surveillance.establishment.finess]
          },
          exclusive: ['region', 'finess']
        },
        {
          key: 'region',
          name: 'Région',
          field: (s) => {
            const ri = this.establishmentByRegions[s.sv]
            const r = regions.filters[ri]
            return [r.name]
          },
          exclusive: ['region', 'finess']
        }
      )
      return result
    },

    sheets: function () {
      if (this.allSheets == null) {
        return null
      }

      if (this.selection == null) {
        return this.allSheets
      }

      return this.allSheets.filter(
        s => s.sv === this.selection.surveillance.id
      )
    },

    filterInputList: function () {
      if (this.sheets == null) {
        return []
      }

      return [
        {
          list: this.sheets,
          variables: this.filterVariables
        }
      ]
    },

    establishmentList: function () {
      return this.getListByName(this.year)
    },

    display: function () {
      return this.loaded &&
             this.distribution != null
    },

    loaded: function () {
      return this.dataset != null &&
             this.establishmentList != null &&
             this.establishmentList.length > 0
    },

    year: function () {
      return this.$route.params.year
    },

    title: function () {
      if (this.selection == null) {
        return `SPIADI${this.year} - DONNÉES NATIONALES`
      }

      const e = this.selection.surveillance.establishment.name
      const y = this.year
      return `SPIADI${y} - ${e}`
    },

    subtitle: function () {
      const f = this.currentFilter
      if (f === '') {
        return ''
      }

      return `Filtre actif : ${f}`
    },

    distribution: function () {
      if (this.referenceSheets == null) {
        return null
      }

      try {
        const dist = distribution('observa4', this.referenceSheets, this.year)
        dist.etbregion = {
          type: 'rep',
          values: {},
          total: 0
        }
        this.referenceSheets.forEach(
          s => {
            const r = this.establishmentByRegions[s.sv]
            const rv = dist.etbregion.values
            if (rv[r] != null) {
              rv[r] += 1
            } else {
              rv[r] = 1
            }
            dist.etbregion.total++
          }
        )
        return dist
      } catch (e) {
        this.$notify({
          type: 'danger',
          title: 'Erreur !',
          duration: 0,
          content: `Une erreur est survenue pendant le calcul des
caractéristiques : ${e}.`
        })
      }
      return null
    }
  },

  components: {
    'sui-observa4-results': suiObserva4Results,
    'sui-filter-bar': suiFilterBar,
    'save-blob': saveBlob,
    'sui-loading-text': suiLoadingText
  }
}
</script>
<style scoped lang="less">
.sticky-footer {
  margin-top: -1.0rem;
  margin-bottom: 0.5rem;
  .btn {
    margin-right: 1rem;
  }
}
</style>
